// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5588":"9bf8dea6","8253":"b9e30a42"}[chunkId] + ".chunk.css";
};